import React, { useState } from 'react'
import { Card, Row, Col, Collapse } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import moment from 'moment'

const HistoryItem = () => {
  const [accordionKey, setAccordionKey] = useState(1)
  const list = [
    {
      id: 1,
      date: '2022-01-13',
      time: '09:20',
      description: 'สร้างเอกสารใบเสนอราคา',
      createBy: 'Lorem Ipsum',
    },
    {
      id: 2,
      date: '2022-03-22',
      time: '14:35',
      description: 'แก้ไขเอกสาร',
      createBy: 'Lorem Ipsum',
    },
    {
      id: 3,
      date: '2022-05-05',
      time: '11:06',
      description: 'แก้ไขเอกสาร',
      createBy: 'Lorem Ipsum',
    },
  ]

  return (
    <>
      {list.map((item) => (
        <Card className="mt-2">
          <Card.Header>
            <Card.Title as="h5">
              <Row>
                <Col sm="12">
                  <Link
                    to="#"
                    onClick={() =>
                      setAccordionKey(accordionKey !== item.id ? item.id : 0)
                    }
                    aria-controls={item.id}
                    aria-expanded={accordionKey === item.id}
                  >
                    <i className="feather icon-chevron-down mr-2 font-medium-3" />
                  </Link>
                  {item.date}
                </Col>
              </Row>
            </Card.Title>
          </Card.Header>
          <Collapse in={accordionKey === item.id}>
            <div id={item.id}>
              <Card.Body>
                <Row>
                  <Col sm="12">
                    <p>
                      {item.time} น.
                      <b className="ml-3">{item.createBy}</b>
                    </p>
                  </Col>
                  <Col sm="12">
                    <p>{item.description}</p>
                  </Col>
                </Row>
              </Card.Body>
            </div>
          </Collapse>
        </Card>
      ))}
    </>
  )
}

export default HistoryItem
